export const selectCommoditiesBySubType = state => {
  const commodities = state.CommodityGroupsReducer.commodities;
  return commodities.reduce((ac, c) => {
    if (ac[c.commoditySubTypeId]) {
      ac[c.commoditySubTypeId].push(c);
    } else {
      ac[c.commoditySubTypeId] = [c];
    }
    return ac;
  }, {});
};

export const selectCommoditiesCatalog = state => {
  const commoditiesCatalog = state.CommodityGroupsReducer.commoditiesCatalog;
  return commoditiesCatalog.map(c => ({ ...c, name: c.commoditySubType }));
};
